<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">人脸布控</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="布控名称" prop="ControlName">
          <el-input v-model="ControlName" placeholder="请输入布控名称"></el-input>
        </el-form-item>
        <el-form-item label="布控状态">
          <el-select v-model="Controlkey" placeholder="请选择">
            <el-option key label="全部" value></el-option>
            <el-option
              v-for="item in ControlStatusArr"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-button-bar">
        <el-button size="mini" @click="onAdd">添 加</el-button>
      </div>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="AuatarUrl" label="头像">
              <template slot-scope="scope">
                <el-avatar shape="square" fit="fill" :src="scope.row.AuatarUrl" :size="50"></el-avatar>
              </template>
            </el-table-column>
            <el-table-column prop="ControlName" label="布控名称"></el-table-column>
            <el-table-column prop="ControlStaus" label="布控状态" :formatter="formatControlStaus"></el-table-column>
            <el-table-column prop="ControlTime" label="创建时间" :formatter="formatDate"></el-table-column>
            <el-table-column prop="ControlOper" label="创建人"></el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button @click="LookDetail(scope.$index, scope.row)" type="text" size="small">布控结果</el-button>
                <el-button @click="editDetail(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteDeil(scope.$index, scope.row)" type="text" size="small">删除</el-button>            
                <el-button v-if="scope.row.ControlStaus==1" @click="concelcontrol(scope.$index, scope.row)" type="text" size="small">取消布控</el-button>
                <el-button v-else-if="scope.row.ControlStaus==2" @click="restartcontrol(scope.$index, scope.row)" type="text" size="small">重新布控</el-button>
                <el-button v-else  @click="gocontrol(scope.$index, scope.row)" type="text" size="small">进行布控</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
export default {
  name: "FaceControl",
  controller: "UI",
  action: "FaceControl",
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      ControlStatusArr: [
        { lable: "未布控", value:0 },
        { lable: "布控中", value:1 },
        { lable: "布控失败", value:2 }
      ],
      Controlkey: "",
      ControlName: "",
      tableData:[],
    };
  },
  created: function () {
    this.search();
  },
  mounted: function () {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onCancel() {
      this.Controlkey = "";
      this.ControlName = "";
    },
    search() {
      this.tableData=[
        {AuatarUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",ControlName:"走势儿童",ControlStaus:0,ControlTime:new Date().format("yyyy-MM-dd hh:mm:ss"),ControlOper:"admin"},
        {AuatarUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",ControlName:"走势儿童",ControlStaus:1,ControlTime:new Date().format("yyyy-MM-dd hh:mm:ss"),ControlOper:"admin"},
        {AuatarUrl:"https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",ControlName:"走势儿童",ControlStaus:2,ControlTime:new Date().format("yyyy-MM-dd hh:mm:ss"),ControlOper:"admin"}
     ];
    },
    onAdd(){
     this.$router.push({
        path: "/plugin/Face/UI/FaceAddControl",
        query: {
          type: "add"
        },
      });
    },
    editDetail(){
           this.$router.push({
        path: "/plugin/Face/UI/FaceAddControl",
        query: {
          type: "edit"
        },
      });
    },
    //进行布控
     gocontrol(){},
    //取消布控
     concelcontrol(){},
     //重新布控
     restartcontrol(){},  
     //删除布控
     deleteDeil(){
       this.concelcontrol();
     },
     //布控结果
     LookDetail(index, row){
        this.$router.push({
        path: "/plugin/Face/UI/FaceResultControl",
        query: {controlObj:row},
      });
     },
     formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    formatControlStaus(row, column){
      let data = row[column.property];
      if(data==null){
        return null;
      }
      var statusstr=""; 
      this.ControlStatusArr.forEach(item=>{
         if(item.value==data){
          statusstr=item.lable;
        }
      });
     return statusstr;
    }   
  },
};
</script>